export type BooleanString = 'Yes' | 'No';

export const printBoolean = (value: any): BooleanString => (value ? 'Yes' : 'No');
